// extracted by mini-css-extract-plugin
export var fallbackContainer = "styles-module__fallbackContainer___MtTxG";